// Whether a failed card payment is about the BILLING ADDRESS, so its message can
// sit under the Billing address block instead of up with the card fields
// (ClickUp 869fa2yjc, "Billing address failure should be under the Billing
// section"). Everything else keeps its place.
//
// Two ways it happens:
//   - recurly.token() refused the form and named only country / postal_code;
//   - the purchase came back with a message about the billing address, e.g.
//     "Your billing address does not match the address on your account."
// A token error that names a card field as well stays with the card.
const BILLING_FIELDS = ['country', 'postal_code'];

export function isBillingAddressFailure(message, fields) {
  const named = Array.isArray(fields) ? fields : [];
  if (named.length > 0) return named.every((f) => BILLING_FIELDS.includes(f));
  return /billing address|address verification/i.test(message || '');
}

// What the customer reads under the Billing block when the order is turned down over the billing address (ClickUp
// 869fma02r): the server's wording says "address", and people went back to the Shipping step to fix it. The ZIP is
// what the card's bank checks. Only that decline is reworded; a token error that names the billing fields keeps the
// text Recurly.js gave, and the report of the failure still carries the server's own message.
export const BILLING_DECLINE_NOTICE = 'We couldn\u2019t process your payment. Please check that your billing ZIP code matches the one on your card statement, then try again.';

export function billingFailureText(message, fields) {
  const named = Array.isArray(fields) ? fields : [];
  return named.length === 0 && isBillingAddressFailure(message, fields) ? BILLING_DECLINE_NOTICE : message;
}
